import { render, staticRenderFns } from "./pre_file_list.vue?vue&type=template&id=1081bcf3&scoped=true"
import script from "./pre_file_list.vue?vue&type=script&lang=js"
export * from "./pre_file_list.vue?vue&type=script&lang=js"
import style0 from "./pre_file_list.vue?vue&type=style&index=0&id=1081bcf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1081bcf3",
  null
  
)

export default component.exports